import restApi from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApi.post("/api/site", params);
};

const getLookUp = () => {
  return restApi.get("/api/site/lookup");
}

const getAllForCSV = params => {
  return restApi.post("/api/site/csv", params);
};

const upsert = data => {
  return restApi.post("/api/site/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/site/${ids}`);
};

const getSiteUsed = () => {
  return restApi.get("/api/site/used");
}

const siteService = {
  getAll,
  getLookUp,
  getAllForCSV,
  upsert,
  remove,
  getSiteUsed
};

export default siteService;